import React, { Component } from 'react';
import { translate } from 'react-i18next';
import config from '../config';

import { Table, Checkbox, Button } from 'react-bootstrap';
import Moment from 'moment';
import Dialog from 'react-bootstrap-dialog';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Link } from 'react-router-dom';
import Switch from 'react-switch';
import TooltipButton from './TooltipButton';

import './TemplateMediaTable.css';

class TemplateMediaTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isDragging: false,
			medialibraryuuid: this.props.medialibraryuuid,
			organisationuuid: this.props.organisationuuid,
			media: this.props.media || [],
			itemsSelected: this.props.itemsSelected,
			editingMediaUuid: null,
			editingName: '',
			editingFolderUuid: null,
			editingFolderName: ''
		};
	}

	// --- inline rename: media ---
	startEditingName = (media, e) => {
		e.stopPropagation();
		this.setState({ editingMediaUuid: media.uuid, editingName: media.name });
	};

	handleNameChange = (e) => {
		this.setState({ editingName: e.target.value });
	};

	handleNameKeyDown = (media, e) => {
		if (e.key === 'Enter') {
			this.saveNameEdit(media);
		} else if (e.key === 'Escape') {
			this.cancelNameEdit();
		}
	};

	saveNameEdit = (media) => {
		const newName = this.state.editingName.trim();
		if (newName && newName !== media.name && this.props.onRenameMedia) {
			this.props.onRenameMedia(media, newName);
		}
		this.setState({ editingMediaUuid: null, editingName: '' });
	};

	cancelNameEdit = () => {
		this.setState({ editingMediaUuid: null, editingName: '' });
	};

	// --- inline rename: sub-folder ---
	startEditingFolder = (folder, e) => {
		e.stopPropagation();
		e.preventDefault();
		this.setState({ editingFolderUuid: folder.uuid, editingFolderName: folder.name });
	};

	handleFolderNameChange = (e) => {
		this.setState({ editingFolderName: e.target.value });
	};

	handleFolderNameKeyDown = (folder, e) => {
		if (e.key === 'Enter') {
			this.saveFolderNameEdit(folder);
		} else if (e.key === 'Escape') {
			this.cancelFolderNameEdit();
		}
	};

	saveFolderNameEdit = (folder) => {
		const newName = this.state.editingFolderName.trim();
		if (newName && newName !== folder.name && this.props.onRenameSubfolder) {
			this.props.onRenameSubfolder(folder, newName);
		}
		this.setState({ editingFolderUuid: null, editingFolderName: '' });
	};

	cancelFolderNameEdit = () => {
		this.setState({ editingFolderUuid: null, editingFolderName: '' });
	};

	handleCopyClicked(media) {
		this.props.onCopyClicked(media);
	}

	humanFileSize(bytes, si) {
		var thresh = si ? 1000 : 1024;
		if (Math.abs(bytes) < thresh) {
			return bytes + ' B';
		}
		var units = si ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
		var u = -1;
		do {
			bytes /= thresh;
			++u;
		} while (Math.abs(bytes) >= thresh && u < units.length - 1);
		return bytes.toFixed(1) + ' ' + units[u];
	}

	componentWillReceiveProps(newProps) {

		console.log(newProps.organisationuuid);
		this.setState({
			medialibraryuuid: newProps.medialibraryuuid,
			organisationuuid: newProps.organisationuuid,
			media: newProps.media || [],
			itemsSelected: newProps.itemsSelected
		});
	}

	toggleSelected(media) {
		this.props.onSelectionChanged(media, !this.getCheckedState(media));
	}

	onBeforeDragStart = () => {
		this.setState({
			isDragging: true
		});
	};

	onDragEnd = result => {
		this.setState({
			isDragging: false
		});

		// dropped outside the list
		if (!result.destination || result.destination.index === result.source.index) {
			return;
		}

		// no movement
		if (result.destination.index === result.source.index) {
			return;
		}

		this.props.onDragEnd(result);
	};

	getCheckedState(media) {
		return this.state.itemsSelected.includes(media);
	}

	handleSwitchChange(checked, media) {
		console.log('click: ' + media.uuid);
		this.props.onEnabledChanged(media, checked);
	}

	handleCheckBoxChange = event => {
		const target = event.target;

		const checked = target.checked;
		const uuid = target.name;

		const media = this.state.media.find(media => {
			return media.uuid === uuid;
		});

		this.props.onSelectionChanged(media, checked);
	};

	render() {
		const noPropagation = e => e.stopPropagation();

		const { t, medialibraryuuid, organisationuuid } = this.props;
		const subfolderBasePath = this.props.subfolderBasePath || '/studiolibraries';
		const subfolders = this.props.subfolders || [];

		let folderRows = subfolders.map(folder => {
			const folderUrl = `${subfolderBasePath}/${folder.uuid}?rel=library`;
			return (
				<tr key={`folder-${folder.uuid}`} className='subfolder-row' style={{ background: '#fbf8ef' }}>
					<td width='20' />
					<td width='150'>
						<Link
							to={folderUrl}
							className='thumbnail'
							style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '84px', width: '150px', marginBottom: 0, background: '#fff' }}
						>
							<em className='fas fa-folder' style={{ fontSize: '40px', color: '#f0ad4e' }} />
						</Link>
					</td>
					<td className='hidden-xs' style={{ verticalAlign: 'middle' }}>
						{this.props.onRenameSubfolder && this.state.editingFolderUuid === folder.uuid ? (
							<input
								type='text'
								className='form-control'
								value={this.state.editingFolderName}
								onChange={this.handleFolderNameChange}
								onKeyDown={(e) => this.handleFolderNameKeyDown(folder, e)}
								onBlur={() => this.saveFolderNameEdit(folder)}
								autoFocus
								style={{ width: '100%' }}
							/>
						) : (
							<Link to={folderUrl} style={{ fontWeight: 600 }}>{folder.name}</Link>
						)}
					</td>
					<td className='hidden-xs hidden-sm' colSpan={4} />
					<td align='center' width='230' style={{ verticalAlign: 'middle' }}>
						<div className='btn-toolbar pull-right'>
							<Link to={folderUrl} className='btn btn-sm btn-default'>
								<em className='fas fa-folder-open' /> {t('TemplateMediaTable.open')}
							</Link>
							{this.props.onRenameSubfolder && (
								<TooltipButton
									className='btn-default btn-sm'
									onClick={e => this.startEditingFolder(folder, e)}
									tooltip={t('TemplateMediaTable.rename')}
								>
									<em className='fas fa-pencil-alt' />
								</TooltipButton>
							)}
							{this.props.onDeleteSubfolder && (
								<TooltipButton
									className='btn-danger btn-sm'
									onClick={e => {
										e.stopPropagation();
										this.props.onDeleteSubfolder(folder);
									}}
									tooltip={t('Dialog.delete')}
								>
									<em className='fas fa-trash' />
								</TooltipButton>
							)}
						</div>
					</td>
				</tr>
			);
		});

		const getItemStyle = (isDragging, draggableStyle) => ({
			// some basic styles to make the items look a bit nicer
			userSelect: 'none',
			background: isDragging ? '#dddddd' : '',
			display: isDragging ? 'table' : '',
			...draggableStyle
		});

		const getListStyle = isDraggingOver => ({
			borderCollapse: isDraggingOver ? 'separate' : 'collapse'
		});

		let mediaRows = this.state.media.map((media, index) => {
			// Check if this is an image type (for text overlay support)
			const isImage = media.extension && ['jpg', 'jpeg', 'png', 'gif'].includes(media.extension.toLowerCase());

			return (
				<Draggable key={media.uuid} draggableId={media.uuid} index={index}>
					{(provided, snapshot) => (
						<tr
							ref={provided.innerRef}
							{...provided.draggableProps}
							{...provided.dragHandleProps}
							onClick={e => {
								e.stopPropagation();
								this.toggleSelected(media);
							}}
							style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
						>
							<td width='20'>
								<Checkbox checked={this.getCheckedState(media)} name={media.uuid} onChange={this.handleCheckBoxChange} />
							</td>
							<td width='150'>
								{media.uploaded ? (
									<div style={{ position: 'relative' }}>
										<a onClick={noPropagation} href={`${config.playersBaseURL}/mediaserver/media/${organisationuuid}/${medialibraryuuid}/${media.uuid}.${media.extension}`} className='thumbnail' target='_blank'>
											<img src={`${config.playersBaseURL}/mediaserver/thumbnails/${organisationuuid}/${medialibraryuuid}/${media.uuid}.jpg`} width='150' />
										</a>
										{media.hasTextOverlay && (
											<span
												className="label label-success"
												style={{ position: 'absolute', top: '5px', right: '5px', fontSize: '10px' }}
											>
												TEXT
											</span>
										)}
										{media.flatteningStatus && (media.flatteningStatus === 'pending' || media.flatteningStatus === 'processing') && (
											<span
												className="label label-warning"
												style={{ position: 'absolute', bottom: '5px', right: '5px', fontSize: '10px' }}
											>
												PROCESSING
											</span>
										)}
										{media.flatteningStatus === 'failed' && (
											<span
												className="label label-danger"
												style={{ position: 'absolute', bottom: '5px', right: '5px', fontSize: '10px' }}
											>
												FAILED
											</span>
										)}
									</div>
								) : (
										<img src={`${config.imagesBaseURL}/misc/processing_spinner.gif`} width='150' />
									)}
							</td>
							<td width='150' className='hidden-xs'>
								{this.props.onRenameMedia && this.state.editingMediaUuid === media.uuid ? (
									<input
										type='text'
										className='form-control'
										value={this.state.editingName}
										onChange={this.handleNameChange}
										onKeyDown={(e) => this.handleNameKeyDown(media, e)}
										onBlur={() => this.saveNameEdit(media)}
										onClick={noPropagation}
										autoFocus
										style={{ width: '100%' }}
									/>
								) : (
									<span
										onClick={this.props.onRenameMedia ? (e => this.startEditingName(media, e)) : undefined}
										style={this.props.onRenameMedia ? { cursor: 'pointer' } : undefined}
										title={this.props.onRenameMedia ? 'Click to rename' : undefined}
									>
										{media.name}
									</span>
								)}
							</td>
							<td width='75' className='hidden-xs hidden-sm'>
								<span className='label label-default'>{media.extension}</span>
							</td>
							<td width='75' className='hidden-xs hidden-sm'>
								<span className='label label-default'>{this.humanFileSize(media.filesize, true)}</span>
							</td>

							<td width='150' className='hidden-xs hidden-sm'>
								{Moment(media.updatedAt).format('YYYY-MM-DD HH:mm')}
							</td>
							<td className='hidden-xs hidden-sm'>
								{Moment(media.createdAt).format('YYYY-MM-DD HH:mm')}
							</td>

							<td align='center' width='230'>
								<div className='btn-toolbar pull-right'>
									{/* Only show text overlay button for images (jpg, png, gif), not videos */}
									{isImage && (
										<Link
											to={`/templatelibraries/${medialibraryuuid}/media/${media.uuid}/edit-text`}
											className={`btn btn-sm ${media.hasTextOverlay ? 'btn-primary' : 'btn-default'}`}
											onClick={e => e.stopPropagation()}
											title={media.hasTextOverlay ? t('TemplateMediaTable.edit_text_overlay') : t('TemplateMediaTable.add_text_overlay')}
										>
											<em className='fas fa-text-width' />
										</Link>
									)}
									<TooltipButton
										disabled={this.state.isDragging}
										className='btn-danger'
										onClick={e => {
											e.stopPropagation();
											this.props.onDeleteMedia(media);
										}}
										tooltip={t('Dialog.delete')}
									>
										<em className='fas fa-trash' />
									</TooltipButton>
								</div>
							</td>
						</tr>
					)}
				</Draggable>
			);
		});

		return (
			<div className='TemplateMediaTable'>
				<Dialog
					ref={el => {
						this.dialog = el;
					}}
				/>
				<DragDropContext onBeforeDragStart={this.onBeforeDragStart} onDragEnd={this.onDragEnd}>
					<Droppable droppableId='droppable'>
						{(provided, snapshot) => (
							<table style={getListStyle(snapshot.isDraggingOver)} ref={provided.innerRef} className='table table-striped'>
								<thead>
									<tr>
										<th width='20' />
										<th width='150'>{t('TemplateMediaTable.thumbnail')}</th>
										<th width='150' className='hidden-xs'>
											{t('TemplateMediaTable.filename')}
										</th>
										<th width='75' className='hidden-xs hidden-sm'>
											{t('TemplateMediaTable.extension')}
										</th>
										<th width='100' className='hidden-xs hidden-sm'>
											{t('TemplateMediaTable.filesize')}
										</th>
										<th width='150' className='hidden-xs hidden-sm'>
											{t('TemplateMediaTable.updated')}
										</th>
										<th className='hidden-xs hidden-sm'>{t('TemplateMediaTable.uploaded')}</th>
										<th>
											<em className='fa fa-cog' />
										</th>
									</tr>
								</thead>
								<tbody>{folderRows}{mediaRows}</tbody>
							</table>
						)}
					</Droppable>
				</DragDropContext>
			</div>
		);
	}
}

export default translate('translations')(TemplateMediaTable);
